<template>
  <div>
    <PageAllow controller="PositionCurrents" action="index" />
    <Breadcrumbs :items="items" />
    <!-- 库位流水明细 -->
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 创建日期 -->
              <SearcherDatetimeRangeWithRadio
                v-model="datetimeRage"
                type="datetime"
                :label="$t('StockPosition.Fields.create')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->

              <v-btn small color="print" dark class="ms-1" href="">
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.stock_position_batch_out") }}
              </v-btn>
              <v-btn small color="print" dark class="ms-1" href="">
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.stock_position_material_out") }}
              </v-btn>
              <!-- <v-btn small color="print" dark class="ms-1" href="">
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("CurrentPosition.Export.stock_position_in") }}
              </v-btn> -->
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓库中心 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStock
                    v-model="stockSelected"
                    :stock-types="[0]"
                    unclearable
                  />
                </v-col>
                <!-- 库区 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockArea v-model="areasSelected" />
                </v-col>
                <!-- 库位 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherPosition v-model="positionSelected" />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial v-model="materialSelected" />
                </v-col>
                <!-- 类型 -->
                <SearcherStatus
                  v-model="options.types"
                  :label="$t('inOutDetail.type.ObjectName')"
                  :items="$consts.positionActivitiesTypes"
                />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="positionActivityItems"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <!-- 均价 -->
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money")
              }}{{ (item.total_price / item.stock_total) | formatMoney }}
            </template>

            <template v-slot:item.material_name="{ item }">
              {{
                settings
                  ? $t(
                      settings
                        ? settings.material_name_display_type == 4
                          ? "Material.nameWithCodeAndStandard"
                          : settings.material_name_display_type == 3
                          ? "Material.materialNameWithCodeAndStandard"
                          : settings.material_name_display_type == 2
                          ? "Material.materialNameWithCode"
                          : "Material.materialName"
                        : "Material.materialName",
                      [
                        item.material_code,
                        item.material_name,
                        item.standard_name,
                      ]
                    )
                  : item.material_name
              }}
            </template>

            <template v-slot:item.type_str="{ item }">
              <span v-if="item.type == 1 || item.type == 3 || item.type == 5">
                <v-chip
                  small
                  label
                  :color="item.type_str ? 'primary' : 'primary'"
                  text-color="white"
                >
                  {{ $t("StockPosition.types.in") }}
                </v-chip>
              </span>
              <span v-if="item.type == 2 || item.type == 4 || item.type == 6">
                <v-chip
                  small
                  label
                  :color="item.type_str ? 'danger' : 'danger'"
                  text-color="white"
                >
                  {{ $t("StockPosition.types.out") }}
                </v-chip>
              </span>
            </template>
            <!-- 单号 -->
            <template v-slot:item.code="{ item }">
              <!-- 跳转出库单详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-if="
                  (item.type == 2 && item.stock_order_type !== 14) ||
                  (item.type == 6 && item.stock_order_type !== 14)
                "
                @click.stop="
                  $router.push({
                    path: '/stock-orders-out/' + item.stock_out_order_id,
                  })
                "
              >
                {{ item.stock_out_order_code }}
              </a>

              <!-- 跳转批次报损详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-if="
                  (item.type == 2 && item.stock_order_type == 14) ||
                  (item.type == 6 && item.stock_order_type == 14)
                "
              >
                {{ item.stock_out_order_code }}
              </a>

              <!-- 跳转入库单详情 -->
              <a
                class="text-no-wrap caption font-weight-bold"
                v-if="item.type == 1 || item.type == 5"
                @click.stop="
                  $router.push({
                    path: '/stock-orders-in/' + item.stock_in_order_id,
                  })
                "
              >
                {{ item.stock_in_order_code }}
              </a>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <!-- 格式化数字 -->
            <template v-slot:item.shelve_num="{ item }">
              {{ item.shelve_num | formatTwoDot }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStock from "@/components/plugins/SearcherStock";
import PositionActivities from "@/api/position_activities";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import SearcherPosition from "@/components/plugins/SearcherPosition";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";

const defaultOptions = {
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  types: [1, 2],
  material_id: null,
  stock_id: 1,
  stock_area_id: null,
  position_label_id: null,
  stock_position_id: null,
};

export default {
  data: () => ({
    position_activities: [],
    stockSelected: null,
    positionSelected: null,
    areasSelected: null,
    materialSelected: null,
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("position_activities-options")
        ? sessionStorage.getItem("position_activities-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    datetimeRage: [
      new Date(new Date().getTime() - 90 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
  }),
  components: {
    Breadcrumbs,
    SearcherStock,
    PageAllow,
    SearcherMaterial,
    SearcherPosition,
    SearcherStatus,
    SearcherStockArea,
    SearcherDatetimeRangeWithRadio,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.currentPosition"),
        disabled: false,
        href: "/current-position",
      },
      {
        text: i18n.t("Nav.StockPosition"),
        disabled: true,
        href: "/position-activities",
      },
    ],
    headers: () => [
      {
        text: i18n.t("StockPosition.Fields.areas"),
        align: "start",
        sortable: false,
        value: "stock_area_name",
      },
      {
        text: i18n.t("StockPosition.Fields.stock_position_name"),
        align: "start",
        sortable: false,
        value: "position_description",
      },
      {
        text: i18n.t("StockPosition.Fields.position_code"),
        align: "start",
        sortable: false,
        value: "bar_code",
      },
      {
        text: i18n.t("StockPosition.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("StockPosition.Fields.material"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("StockPosition.Fields.type"),
        align: "center",
        sortable: false,
        value: "type_str",
      },
      {
        text: i18n.t("StockPosition.Fields.num"),
        align: "end",
        sortable: false,
        value: "shelve_num",
      },
      {
        text: i18n.t("StockPosition.Fields.unit"),
        align: "center",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("StockPosition.Fields.stock_in_out_order_code"),
        align: "center",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("StockPosition.Fields.operater_name"),
        align: "center",
        sortable: false,
        value: "operater_name",
      },
    ],
    positionActivityItems() {
      return this.position_activities.map((position) => {
        var position_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [position.bar_code, position.position_name]
        );
        if (this.stockSelected && this.stockSelected.position_name_display) {
          if (this.stockSelected.position_name_display.indexOf(2) > -1) {
            position_description = position.position_name;
          }
          if (
            this.stockSelected.position_name_display.indexOf(4) > -1 &&
            position.roadway_code
          ) {
            position_description =
              position.roadway_code + " - " + position_description;
          }
          if (
            this.stockSelected.position_name_display.indexOf(3) > -1 &&
            position.stock_area_name
          ) {
            position_description =
              position.stock_area_name + " - " + position_description;
          }
        }

        return Object.assign({}, position, { position_description });
      });
    },
    ...mapState(["settings"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("position_activities", [
        "stockSelected",
        "areasSelected",
        "positionSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockSelected":
                this.stockSelected = selected.value;
                break;
              case "areasSelected":
                this.areasSelected = selected.value;
                break;
              case "positionSelected":
                this.positionSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stockSelected = null;
      this.areasSelected = null;
      this.positionSelected = null;
      this.materialSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
    },
    getContainersFromAPI() {
      this.loading = true;
      PositionActivities.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.position_activities = response.data.position_activities;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getContainersFromAPI();
        sessionStorage.setItem(
          "position_activities-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stockSelected: {
      handler() {
        this.options.stock_id = this.stockSelected
          ? this.stockSelected.id
          : null;
        sessionStorage.setItem(
          "position_currents-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    // 库区
    areasSelected: {
      handler() {
        this.options.stock_area_id = this.areasSelected
          ? this.areasSelected.id
          : null;
        sessionStorage.setItem(
          "position_activities-areasSelected",
          JSON.stringify(this.areasSelected)
        );
      },
    },
    // 库位
    positionSelected: {
      handler() {
        this.options.stock_position_id = this.positionSelected
          ? this.positionSelected.id
          : null;
        sessionStorage.setItem(
          "position_activities-positionSelected",
          JSON.stringify(this.positionSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected.id
          : null;
        sessionStorage.setItem(
          "position_currents-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.create_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.create_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.create_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.create_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>

<style>
</style>